import { render, staticRenderFns } from "./Nation.vue?vue&type=template&id=154fec13&"
import script from "./Nation.vue?vue&type=script&lang=js&"
export * from "./Nation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports